const QUEUE_KEY = "pos_offline_queue";
const ITEMS_KEY = "pos_items_cache";

export function getQueue() {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]"); } catch { return []; }
}
export function setQueue(q) { localStorage.setItem(QUEUE_KEY, JSON.stringify(q)); }
export function enqueueSale(sale) { setQueue([...getQueue(), sale]); }

export function cacheItems(items) { localStorage.setItem(ITEMS_KEY, JSON.stringify(items)); }
export function getCachedItems() {
  try { return JSON.parse(localStorage.getItem(ITEMS_KEY) || "[]"); } catch { return []; }
}

export function buildOfflineSale(payload, cart) {
  const subtotal = cart.reduce((s, l) => s + l.qty * l.price - l.discount, 0);
  const total = Math.max(0, subtotal - payload.total_discount);
  const now = new Date();
  const ts = now.toISOString();
  return {
    ...payload,
    client_id: `off-${now.getTime()}-${Math.random().toString(36).slice(2, 8)}`,
    offline_at: ts,
    created_at: ts,
    number: `OFF-${now.getTime().toString().slice(-6)}`,
    items: cart.map((l) => ({ ...l, subtotal: l.qty * l.price - l.discount })),
    subtotal, total,
    paid_amount: payload.paid_amount || total,
    change: Math.max(0, (payload.paid_amount || total) - total),
  };
}
